import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
} from 'react';
import classNames from 'classnames';

import {
  Actions,
  Button,
} from '@ktag/styleguide/dist/react';

import { AppForm, FormConfigStore } from 'ewp-common';

import FormDataStore from '../../../stores/formDataStore';
import ResidenceInfo from './ResidenceInfo';
import PersonalInfo from './PersonalInfo';
// import AppForm from '../../appForm/react/AppForm';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
  setRoute?: Dispatch<SetStateAction<number>>,
  cancel?: () => void
}

const Step1 = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
    setRoute,
  } = props;
  const {
    state: formDataState,
    setPersonal,
    setDeliveryInfo,
  } = useContext(FormDataStore.FormDataContext);

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const configs = formConfigState?.data?.labelsMap;
  
  const onSubmit = (values) => {
    setPersonal({
      ...values.personal,
      link: values.link
    });
    if (!values.deliveryInfo.fieldAddressNotFound) {
      if (values.deliveryInfo.fieldDeliveryAddressDifferent !== 'Ja') {
        setDeliveryInfo({
          fieldDeliveryAddressDifferent: 'Nein',
          fieldDeliveryLastname: '',
          fieldDeliveryFirstname: '',
          fieldDeliveryCompany: '',
          fieldAddress: '',
          fieldStrasse: '',
          fieldNr: '',
          fieldPlz: '',
          fieldOrt: '',
          fieldLand: 'Schweiz',
        });
      } else {
        setDeliveryInfo({
          ...values.deliveryInfo,
        });
      }
    }
    setRoute(3);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <AppForm
        onSubmit={onSubmit}
        initialValues={formDataState}
        robot={true}
      >
        {
          () => (
            <div>
              <PersonalInfo />
              <ResidenceInfo />
              <div className="dummy-submit-btn" dangerouslySetInnerHTML={{ __html: '<button type=submit disabled style="display:none;" aria-hidden="true"></button>' }} />
              <Actions label={configs.btnNext?.labelDisplayName}>
                <Actions.Left>
                  <Button
                    label={configs.btnCancel?.labelDisplayName}
                    onClick={() => setRoute(1)}
                  />
                </Actions.Left>
              </Actions>
            </div>
          )
        }
      </AppForm>
    </div>
  );
};

Step1.defaultProps = {
  id: '',
  className: 'step1',
  additionalClassNames: '',
};

export default Step1;
